/*
 * @Author: your name
 * @Date: 2020-07-23 22:27:18
 * @LastEditTime: 2020-07-23 22:27:33
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /x-product-h5-workspace/packages/xdap-h5/src/locale/lang/en/index.js
 */
const locale = {}

export default locale
